import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { PaginationInput } from '@/gql/graphql';

const GET_MY_ACCOUNT_WEBHOOKS = graphql(`
  query MyAccountWebhooks($pagination: PaginationInput) {
    me {
      user {
        account {
          webhooks(pagination: $pagination) {
            limit
            offset
            totalCount
            items {
              id
              name
              url
              events
              apiVersion
            }
          }
        }
      }
    }
  }
`);

const useGetMyAccountWebhooks = (pagination: PaginationInput) => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.accountWebhooks(pagination),
    queryFn: () => {
      return gqlClient.request(GET_MY_ACCOUNT_WEBHOOKS, {
        pagination,
      });
    },
  });

  return { data: data?.me.user.account.webhooks, ...rest };
};

export default useGetMyAccountWebhooks;
